import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import {
  $getSelection,
  $isRangeSelection,
  $getRoot,
  COMMAND_PRIORITY_EDITOR,
  createCommand,
} from 'lexical';
import { $getNearestBlockElementAncestorOrThrow } from '@lexical/utils';
import { $createPageBreakNode, PageBreakNode } from '../../nodes/PageBreakNode';

export const INSERT_PAGE_BREAK = createCommand('INSERT_PAGE_BREAK');

export default function PageBreakPlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (!editor.hasNodes([PageBreakNode])) {
      throw new Error('PageBreakPlugin: PageBreakNode not registered on editor');
    }

    return editor.registerCommand(
      INSERT_PAGE_BREAK,
      () => {
        const pgBreak = $createPageBreakNode();
        const selection = $getSelection();
        if ($isRangeSelection(selection)) {
          const focusNode = selection.focus.getNode();
          if (focusNode !== null) {
            $getNearestBlockElementAncestorOrThrow(focusNode).insertAfter(pgBreak);
            pgBreak.selectNext();
            return true;
          }
        }

        // Fallback: when toolbar interaction blurs editor and selection is lost,
        // insert the page break at the end so command still works.
        $getRoot().append(pgBreak);
        pgBreak.selectNext();
        return true;
      },
      COMMAND_PRIORITY_EDITOR
    );
  }, [editor]);

  return null;
}

